import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { subscriptionRepository } from '../repositories/supabaseSubscriptionRepository';

export function useMyAccountProfile() {
  const { user } = useAuth();

  const { data, isLoading, error } = useQuery({
    queryKey: ['my-account-profile', user?.id],
    queryFn: () => subscriptionRepository.fetchMyAccountProfile(user!.id),
    enabled: !!user,
    staleTime: 5 * 60 * 1_000,
  });

  return {
    isInstructor: data?.isInstructor === true,
    isLoading,
    error: error instanceof Error ? error.message : null,
  };
}
